import { render, staticRenderFns } from "./ItsSalesOuterAbroadDetail.vue?vue&type=template&id=5d680555&scoped=true&"
import script from "./ItsSalesOuterAbroadDetail.vue?vue&type=script&lang=js&"
export * from "./ItsSalesOuterAbroadDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsSalesOuterAbroadDetail.vue?vue&type=style&index=0&id=5d680555&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d680555",
  null
  
)

export default component.exports